export enum SignalPlanStatusEnum {
    ACTIVE = 1,
    PAUSED = 2,

}
